// Getter to retrieve state data
export const getResources = (state) => {
    return state.resources;
};
